import Swiper, { EffectFade } from 'swiper';

class AccessoriesDetail {
    constructor ($element) {
        this.$accessorie = $element;
        this.$accessorieImageSlider = this.$accessorie.querySelector('[data-accessorie-image-slider="root"]');
        this.$accessorieImage = this.$accessorie.querySelector('[data-accessorie-image]');
        this.$accessorieImageThumbnails = this.$accessorie.querySelector('[data-accessorie-thumbnails="root"]');
        this.accessorieSlider = undefined;
        this.textBlock = this.getLastTextblock();

        this.imageType = 'fixed';
        this.editmode = document.body.getAttribute('data-editmode') === '';
    }

    initialize () {
        if (this.$accessorieImageThumbnails) {
            if (this.$accessorieImageThumbnails.querySelectorAll('[data-accessorie-thumbnail]').length > 1) {
                this.initSlider();
            }
        }

        this.setEvents();
        this.checkScrollPosition(window.pageYOffset);
    }

    initSlider () {
        this.accessorieSlider = new Swiper(this.$accessorieImageSlider, {
            modules: [EffectFade],
            slidesPerView: 1,
            spaceBetween: 10,
            resistanceRatio: 0,
            speed: 700,
            effect: 'fade'
        });
    }

    setEvents () {
        if (this.$accessorieImageThumbnails) {
            this.$accessorieImageThumbnails.addEventListener('click', (e) => {
                const index = e.target.getAttribute('data-accessorie-thumbnail');

                if (index !== null) {
                    this.accessorieSlider.slideTo(index - 1);
                    if (!e.target.classList.contains('is--active')) {
                        this.$accessorieImageThumbnails.querySelector('.is--active').classList.remove('is--active');
                        e.target.classList.add('is--active');
                    }
                }
            });

            this.accessorieSlider.on('transitionStart', () => {
                const index = this.accessorieSlider.activeIndex + 1;
                this.$accessorieImageThumbnails.querySelector('.is--active').classList.remove('is--active');

                const $targetIndex = this.$accessorieImageThumbnails.querySelector('[data-accessorie-thumbnail="' + index + '"]');

                if ($targetIndex) {
                    $targetIndex.classList.add('is--active');
                }
            });
        }
    }

    checkScrollPosition (position) {
        if (!this.editmode && window.innerWidth >= 768 && this.textBlock) {
            if ((position > 0 && (this.textBlock.getBoundingClientRect().bottom - this.$accessorieImage.clientHeight - 180) >= 0) && (this.imageType === 'relative' || this.imageType === 'absolute')) {
                this.imageType = 'fixed';
                this.$accessorieImage.classList.remove('is--absolute');

                if (!this.$accessorieImage.classList.contains('is--fixed')) {
                    this.$accessorieImage.style.top = 'unset';
                }

                this.$accessorieImage.classList.add('is--fixed');
            } else if (this.imageType === 'fixed' && this.textBlock.getBoundingClientRect().bottom - this.$accessorieImage.clientHeight - 180 < 0) {
                this.imageType = 'absolute';
                this.$accessorieImage.classList.remove('is--fixed');

                if (!this.$accessorieImage.classList.contains('is--absolute')) {
                    this.$accessorieImage.style.top = (this.textBlock.getBoundingClientRect().bottom + position - this.$accessorieImage.clientHeight - 180) + 'px';
                }
                this.$accessorieImage.classList.add('is--absolute');
            } else if ((position <= 0 && this.imageType === 'fixed')) {
                this.imageType = 'relative';
                this.$accessorieImage.classList.remove('is--fixed');
                this.$accessorieImage.classList.remove('is--absolute');
            }
        }
    }

    /**
     * get all textblock modules of the page and check if it is the
     * last one which does not follow up with another module
     * this is needed to make sure the Accessorie images scrolls down
     * to the last text block, even when there are multiple textblocks
     * following one another.
     */
    getLastTextblock () {
        const $$textblocks = this.$accessorie.querySelectorAll('.textblock');

        for (let i = 0; i < $$textblocks.length; i++) {
            const $textblock = $$textblocks[i];
            const $nextSibling = $textblock.nextElementSibling;

            if ($nextSibling) {
                if (!$nextSibling.classList.contains('textblock')) {
                    return $textblock;
                }
            } else {
                return $textblock;
            }
        }

        return null;
    }
}

export { AccessoriesDetail };
